/**
 * AdminMarketingPromocionesPlantillasView — Web Component (Light DOM)
 *
 * Vista de Marketing del panel de administración.
 * Contiene tres tabs:
 *   - Promociones: listado de promociones activas con creación desde plantillas.
 *   - Presets (Plantillas): gestión de plantillas de promoción reutilizables.
 *   - Buscador e Historial: búsqueda de recompensas, promos, clientes y referidos.
 * Migrado desde index.html (sección Marketing).
 */
import { t } from '../../services/i18n-admin.js';
import { icon } from '../../utils/icon.js';

export class AdminMarketingPromocionesPlantillasView extends HTMLElement {
    connectedCallback() {
        this.innerHTML = `
                    <!-- MARKETING VIEW -->
                    <section class="view" id="view-marketing">
                        <div class="section-header">
                            <h3 class="section-title">${t('Marketing')}</h3>
                            <div class="view-tabs">
                                <button
                                    class="tab-btn active"
                                    data-tab="promociones"
                                    data-action="app:switchTab"
                                    data-view="marketing"
                                >
                                    ${icon('tag')} ${t('Promociones')}
                                </button>
                                <button
                                    class="tab-btn"
                                    data-tab="analisis"
                                    data-action="app:switchTab"
                                    data-view="marketing"
                                >
                                    ${icon('bar-chart-2')} ${t('Análisis')}
                                </button>
                                <button
                                    class="tab-btn"
                                    data-tab="presets"
                                    data-action="app:switchTab"
                                    data-view="marketing"
                                >
                                    ${icon('copy')} ${t('Crear/Modificar Plantillas')}
                                </button>
                                <button
                                    class="tab-btn"
                                    data-tab="cupones"
                                    data-action="app:switchTab"
                                    data-view="marketing"
                                >
                                    ${icon('tag')} ${t('Cupones')}
                                </button>
                                <button
                                    class="tab-btn"
                                    data-tab="tickets"
                                    data-action="app:switchTab"
                                    data-view="marketing"
                                >
                                    ${icon('ticket')} ${t('Tickets')}
                                </button>
                                <button
                                    class="tab-btn"
                                    data-tab="referidos"
                                    data-action="app:switchTab"
                                    data-view="marketing"
                                >
                                    ${icon('users')} ${t('Buscador e Historial')}
                                </button>
                            </div>
                        </div>

                        <!-- TAB: Promociones -->
                        <div class="tab-content active" id="tab-marketing-promociones">
                            <div class="toolbar">
                                <button class="btn btn-primary" data-action="marketing:mostrarSelectorPlantillas">
                                    ${icon('plus')} ${t('Nueva Promocion')}
                                </button>
                            </div>
                            <div id="marketing-promociones-list"></div>
                        </div>

                        <!-- TAB: Análisis — KPIs agnósticos de cada promo (salud, embudo, costo) -->
                        <div class="tab-content" id="tab-marketing-analisis" style="display: none">
                            <div id="marketing-analisis-timeline"></div>
                            <div id="marketing-analisis-promos"></div>
                        </div>

                        <!-- TAB: Plantillas (Presets) -->
                        <div class="tab-content" id="tab-marketing-presets" style="display: none">
                            <div class="toolbar">
                                <button class="btn btn-primary" data-action="marketing:abrirModalCrearPlantilla">
                                    ${icon('plus')} ${t('Nueva Plantilla')}
                                </button>
                                <button
                                    id="btnTogglePresets"
                                    class="btn btn-secondary btn-sm"
                                    data-action="marketing:toggleExpandAllPresets"
                                >
                                    ${icon('chevron-down')} ${t('Expandir')}
                                </button>
                            </div>
                            <div id="marketing-presets-list"></div>
                        </div>

                        <!-- TAB: Cupones (§5) — Campañas onboarding pre_impreso/qr_lluvia_tv/qr_mostrador -->
                        <div class="tab-content" id="tab-marketing-cupones" style="display: none">
                            <div id="marketing-cupones-list"></div>
                        </div>

                        <!-- TAB: Tickets — Promociones de tickets al portador (efecto sobre premio) -->
                        <div class="tab-content" id="tab-marketing-tickets" style="display: none">
                            <div id="marketing-tickets-list"></div>
                        </div>

                        <!-- TAB: Buscador e Historial -->
                        <div class="tab-content" id="tab-marketing-referidos" style="display: none">
                            <div class="toolbar" style="gap: 8px">
                                <select
                                    class="form-input"
                                    id="marketingBuscarTipo"
                                    data-action="marketing:onBuscarTipoChange"
                                    style="max-width: 220px"
                                >
                                    <option value="historial">${t('Historial de recompensas')}</option>
                                    <option value="promociones">${t('Promociones activas')}</option>
                                    <option value="plantillas">${t('Plantillas')}</option>
                                    <option value="clientes">${t('Clientes con promos')}</option>
                                    <option value="referidos">${t('Referidos')}</option>
                                </select>
                                <div class="search-container" style="max-width: 300px">
                                    <input
                                        type="text"
                                        class="form-input"
                                        id="marketingBuscarInput"
                                        placeholder="${t('Buscar...')}"
                                        data-action="marketing:debounceBuscar"
                                    />
                                </div>
                            </div>
                            <div id="marketing-buscar-result"></div>
                        </div>
                    </section>
        `;
    }
}

customElements.define('admin-marketing-promociones-plantillas-view', AdminMarketingPromocionesPlantillasView);
